import { useContext } from "react";
import constants from "../constants";
import { getDataFromStorage } from "../util";
import AlertContext from "../context/AlertContext";
import useSubmitAssignment from "./useSubmitAssignment";
import useCommonFunctionHooks from "./useCommonFunctionHooks";

export default function SandPackEditorHooks() {
  const Alert = useContext(AlertContext);

  const submitAssignment = useSubmitAssignment();
  const { getCatchBlockDetails } = useCommonFunctionHooks();

  const handleBack = () => {
    Alert.setShowNotify({
      show: false,
    });

    if (Alert.isFullScreensp) {
      document.exitFullscreen();
      Alert.setIsFullScreensp(false);
    }

    Alert.setIsAddSubmission(false);
    Alert.setIsEditSubmission(false);

    if (!Alert.openSandpackEditor) {
      if (Alert.isAdmin || getDataFromStorage("role") === "customer") {
        Alert.navigate("/assignment");
      } else if (Alert.showBreadCrumbsData.from === "learner") {
        Alert.navigate("/main/dashboard/testresults");
      } else {
        Alert.setUpdateLeftNav(true);
        Alert.navigate("/home");
      }
    } else {
      Alert.setOpenSandpackEditor(false);
    }
  };

  const closeAssignment = async (from) => {
    Alert.stopProctoring.current.stop = true;

    try {
      Alert.setIsLoaded(true);

      let response = await submitAssignment(
        {
          isSave: false,
          libId: Alert.testData.libid,
          lpId: sessionStorage.getItem("lpId"),
          template: Alert.contentData.template,
          lpConfigId: Alert.testData.lpconfigid,
          learnerNotes: Alert.learnerNotes ? Alert.learnerNotes : "",
          file: {
            contentType: "json",
            file: Alert.sandpackFiles,
            name: `${getDataFromStorage("learnerid")}.json`,
          },
        },
        true
      );
      console.log("Response:",response);
      
      if (response.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        Alert.setShowNotify({
          show: true,
          title: "Error",
          msg:
            response.data === ""
              ? "Something went wrong. Please try again later"
              : response.data.message,
        });
      } else {
        let newFiles = [],
          filePath = "";

        if (process.env.REACT_APP_DEPLOYMENT === "AWS")
          filePath = `SandpackFiles/library/submission/${
            Alert.testData.libid
          }/${getDataFromStorage("learnerid")}.json`;
        else
          filePath = `library/submission/${getDataFromStorage(
            "learnerid"
          )}/${getDataFromStorage("learnerid")}.json`;

        newFiles.push(filePath);

        let assignmentData = JSON.parse(JSON.stringify(Alert.contentData));

        assignmentData.commentsdata = [];
        assignmentData.anslinks = JSON.stringify(newFiles);
        assignmentData.answer = Alert.learnerNotes;
        assignmentData.submitteddate = new Date();

        Alert.setContentData(assignmentData);
        Alert.setIsSubmitted(true);
        Alert.setIsEditSubmission(false);
        Alert.setIsAddSubmission(false);
        Alert.setLpData({});

        if (from !== "back") {
          Alert.setShowNotify({
            show: true,
            title: "Success",
            msg: response.data.message,
            primaryButtonFunction: handleBack,
          });
        } else {
          handleBack();
        }
      }
    } catch (err) {
      getCatchBlockDetails(err);
    } finally {
      Alert.setIsLoaded(false);
    }
  };

  return { closeAssignment, handleBack };
}
